import type { IconData } from '@stacksjs/iconify-core'

export const shoppingShippingBag1: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M31.24 6.86h-6.09V2.29h-1.53v4.57h-6.09V2.29H16v4.57H8.38V2.29H6.86v4.57H.76v24.38h30.48ZM20.57 29.72H2.29V8.38h18.28Zm9.15 0h-1.53v-1.53h-1.52v-1.52h-1.52v1.52h-1.53v1.53H22.1v-1.53h1.52v-1.52h1.53V8.38h1.52v18.29h1.52v1.52h1.53ZM17.53.76h6.09v1.53h-6.09Zm-9.15 0H16v1.53H8.38Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default shoppingShippingBag1
